module.exports = __webpack_public_path__ + "static/media/rub-out-the-write-word.88940aca.jpg";